import { createFileRoute } from '@tanstack/react-router';

import { Remarkable } from 'src/apps/device/components';

export const Route = createFileRoute('/_auth/_layout/device/remarkable')({
  component: () => <Remarkable />,
});
